export const hostName = () => {
  if (process.env.NODE_ENV === "production") {
    return "bingo.eni-eni.com"
  } else {
    return "localhost:3000"
  }
}